import { Navigate, Route, Routes } from "react-router-dom";
import TenantProtectedRoutes from "./TenantProtectedRoutes";
import { SchlParentDashboard } from "../components/admin/ParentAdmin/Dashboard/SchlParentDashboard";
import ParentLayout from "../components/admin/ParentAdmin/Layout/ParentLayout";
import { SchlParentSettings } from "../components/admin/ParentAdmin/Account/SchlParentSettings";
import { SchoolParentQuests } from "../components/admin/ParentAdmin/KidInfo/SchlParentQuests";
import { SchoolParentQuestInfo } from "../components/admin/ParentAdmin/KidInfo/SchlParentQuestInfo";
import { SchlStudentNotifications } from "../components/admin/StudentAdmin/Notification/StudentNotification";
import { SchlStudentNotificationDetail } from "../components/admin/StudentAdmin/Notification/StudentNotificationDetail";

const SchoolParentDashboardRoutes = () => (
  <>
    <Routes>
      <Route
        path=""
        element={
          <TenantProtectedRoutes tenantType="parent">
            <ParentLayout parentType="parent" type="pnormal" />
          </TenantProtectedRoutes>
        }
      >
        <Route path="dashboard/" element={<SchlParentDashboard />} />
        <Route
          path="reciever/notifications"
          element={<SchlStudentNotifications type="pnormal" />}
        />
        <Route
          path="reciever/notification/view/:id"
          element={<SchlStudentNotificationDetail type="pnormal" />}
        />
        <Route path="settings" element={<SchlParentSettings />} />
        <Route path="quests/:studentId" element={<SchoolParentQuests />} />
        <Route
          path="quests/:studentId/:questId"
          element={<SchoolParentQuestInfo />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  </>
);

export default SchoolParentDashboardRoutes;
